import { useSelector, useDispatch } from "react-redux";
import { storeHandler } from "../../api/store/storeActions";

interface ItemSchema {
    _id: string;
    title: string;
}

interface MobileFilterTagsProps {
    onRemoveFilter: (filterType: string, item: ItemSchema) => void;
}

export function MobileFilterTags({ onRemoveFilter }: MobileFilterTagsProps) {
    const dispatch = useDispatch<any>();

    // Get all applied filters from Redux state
    const adType = useSelector((state: any) => state.data.adType) || [];
    const brand = useSelector((state: any) => state.data.brand) || [];
    const category = useSelector((state: any) => state.data.category) || [];
    const country = useSelector((state: any) => state.data.country) || [];
    const dtLevel = useSelector((state: any) => state.data.dtLevel) || [];
    const feature = useSelector((state: any) => state.data.feature) || [];
    const language = useSelector((state: any) => state.data.language) || [];
    const orientation = useSelector((state: any) => state.data.orientation) || [];
    const region = useSelector((state: any) => state.data.region) || [];
    const stage = useSelector((state: any) => state.data.stage) || [];
    const subBrand = useSelector((state: any) => state.data.subBrand) || [];
    const brandCollab = useSelector((state: any) => state.data.brandCollab) || [];
    const year = useSelector((state: any) => state.data.year) || [];
    const mediaType = useSelector((state: any) => state.data.mediaType) || [];

    // Combine all filters into a single array with their types
    const allFilters = [
        ...region.map((item: ItemSchema) => ({ ...item, type: 'region' })),
        ...country.map((item: ItemSchema) => ({ ...item, type: 'country' })),
        ...dtLevel.map((item: ItemSchema) => ({ ...item, type: 'dtLevel' })),
        ...adType.map((item: ItemSchema) => ({ ...item, type: 'adType' })),
        ...category.map((item: ItemSchema) => ({ ...item, type: 'category' })),
        ...feature.map((item: ItemSchema) => ({ ...item, type: 'feature' })),
        ...brand.map((item: ItemSchema) => ({ ...item, type: 'brand' })),
        ...subBrand.map((item: ItemSchema) => ({ ...item, type: 'subBrand' })),
        ...brandCollab.map((item: ItemSchema) => ({ ...item, type: 'brandCollab' })),
        ...language.map((item: ItemSchema) => ({ ...item, type: 'language' })),
        ...orientation.map((item: ItemSchema) => ({ ...item, type: 'orientation' })),
        ...stage.map((item: ItemSchema) => ({ ...item, type: 'stage' })),
        ...year.map((item: ItemSchema) => ({ ...item, type: 'year' })),
        // Handle mediaType as strings
        ...mediaType.map((item: string) => ({ _id: item, title: item.charAt(0).toUpperCase() + item.slice(1), type: 'mediaType' })),
    ];

    const handleRemoveFilter = (filterType: string, item: any) => {
        // Call the parent's remove function
        onRemoveFilter(filterType, item);
    };

    // Don't render if no filters are applied
    if (allFilters.length === 0) {
        return null;
    }

    return (
        <div className="w-full px-4 py-2 bg-white border-b border-gray-200">
            <div className="flex flex-wrap gap-2">
                {allFilters.map((filter, index) => (
                    <div
                        key={`${filter.type}-${filter._id}-${index}`}
                        className="flex items-center gap-1 bg-gray-100 border border-gray-300 rounded-full px-3 py-1 text-sm"
                    >
                        <span className="text-gray-700">{filter.title}</span>
                        <button
                            onClick={() => handleRemoveFilter(filter.type, filter.type === 'mediaType' ? filter._id : filter)}
                            className="flex items-center justify-center w-4 h-4 bg-gray-300 hover:bg-gray-400 rounded-full transition-colors"
                            aria-label={`Remove ${filter.title} filter`}
                            type="button"
                        >
                            <span className="text-gray-600 text-xs font-bold">×</span>
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}
